import { combineReducers } from 'redux-immutable';
import app from './components/containers/App/reducer';
import renewalsPortal from './components/containers/renewals/RenewalsPortal/reducer';

export default combineReducers({
  app,
  renewalsPortal
});
